import { useEffect, useRef, useState } from 'react'
import { MarketResultServices } from '../services/McDataServices'

const firmCache = new Map()
const inflight = new Map()

export const getFirm = id => {
  if (firmCache.has(id)) return Promise.resolve(firmCache.get(id))
  if (!inflight.has(id)) {
    inflight.set(id,
      MarketResultServices.FetchFirmDetails({ url_codes: [id] }).then(data => {
        const f = data.p7Firms?.[0] || {}
        firmCache.set(id, f)
        inflight.delete(id)
        return f
      }).catch(e => {
        inflight.delete(id)
        throw e
      })
    )
  }
  return inflight.get(id)
}

export default function useFirmDetails (id) {
  const [firm, setFirm] = useState(firmCache.get(id))
  const mounted = useRef(true)
  useEffect(() => {
    mounted.current = true
    getFirm(id).then(f => { if (mounted.current) setFirm(f) }).catch(() => {})
    return () => { mounted.current = false }
  }, [id])
  return firm || {}
}
